import axios from "axios";
import { backendUri } from "@/utils/settings";

const getLeaderboard = async () => {
  const response = await axios.get(backendUri + "api/game/ext/leaderboard/");

  return response.data;
};

export { getLeaderboard };
